import { render, staticRenderFns } from "./FooterLinkSection.vue?vue&type=template&id=016a9640&"
import script from "./FooterLinkSection.vue?vue&type=script&lang=js&"
export * from "./FooterLinkSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports